import { useNavigate, useLocation } from "react-router-dom";

const snsLinks = [
  {
    icon: "ri-twitter-x-line",
    label: "むぎ茶",
    url: "https://x.com/mazo_kawaii",
  },
  {
    icon: "ri-twitter-x-line",
    label: "からだめぐり",
    url: "https://x.com/mazo_kawaii2",
  },
  {
    icon: "ri-twitter-x-line",
    label: "お仕置きBAR",
    url: "https://x.com/osioki_bar",
  },
  {
    icon: "ri-links-line",
    label: "Lit.Link",
    url: "https://lit.link/hatomugicha91",
  },
];

const navLinks = [
  { label: "About", href: "/#about" },
  { label: "Session", href: "/#session" },
  { label: "Price", href: "/#price" },
  { label: "Schedule", href: "/#schedule" },
  { label: "Gallery", href: "/#gallery" },
  { label: "Links/ SNS", href: "/#blog" },
  { label: "reservation", href: "/#contact" },
];

export default function FooterSection() {
  const navigate = useNavigate();
  const location = useLocation();

  const isMobile = () => window.innerWidth < 768;

  const handleNavLink = (href: string) => {
    const hash = href.includes("#") ? href.split("#")[1] : null;
    const path = href.startsWith("/#") ? "/" : href.replace(/#.*$/, "");

    if (location.pathname === "/" && hash) {
      const el = document.getElementById(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }
    if (hash) {
      navigate(path);
      setTimeout(() => {
        const el = document.getElementById(hash);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } else {
      navigate(path);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleBooking = () => {
    if (location.pathname === "/reservation") {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    if (isMobile() && location.pathname === "/") {
      const el = document.getElementById("contact");
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }
    navigate("/reservation");
  };

  return (
    <footer className="bg-stone-950">
      <div className="max-w-4xl mx-auto px-5 md:px-10 py-12 md:py-10">

        {/* ブランド名 */}
        <div className="text-center mb-10">
          <p className="text-xs tracking-[0.45em] text-stone-500 uppercase mb-3">Femdom / SM</p>
          <p className="text-2xl md:text-3xl font-light tracking-[0.3em] text-white">
            Mugi Cha Production
          </p>
          <div className="w-8 h-px bg-stone-700 mx-auto mt-5 mb-7" />

          {/* 予約ボタン */}
          <button
            onClick={handleBooking}
            className="inline-flex items-center gap-3 px-8 py-3.5 bg-amber-600 active:bg-amber-700 transition-all duration-200 cursor-pointer rounded-full whitespace-nowrap active:scale-[0.97]"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-calendar-check-line text-white text-base"></i>
            </div>
            <span className="text-[15px] text-white tracking-[0.15em] font-medium">ご予約はこちら</span>
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-line text-white/60 text-sm"></i>
            </div>
          </button>
        </div>

        {/* SNSリンク */}
        <div className="flex items-center justify-center gap-2.5 flex-wrap mb-10">
          {snsLinks.map((sns) => (
            <a
              key={sns.url}
              href={sns.url}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="flex items-center gap-2 px-4 py-2.5 rounded-full border border-stone-700 active:border-stone-400 active:bg-stone-800 active:scale-[0.97] transition-all duration-150 cursor-pointer"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${sns.icon} text-stone-400 text-sm`}></i>
              </div>
              <span className="text-sm text-stone-400 whitespace-nowrap">{sns.label}</span>
            </a>
          ))}
        </div>

        {/* ナビリンク */}
        <div className="flex items-center justify-center gap-x-6 gap-y-4 flex-wrap mb-10">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => handleNavLink(link.href)}
              className="text-sm tracking-[0.15em] text-stone-400 active:text-white transition-colors duration-150 whitespace-nowrap cursor-pointer bg-transparent border-none p-0 active:scale-[0.97]"
            >
              {link.label}
            </button>
          ))}
        </div>

        {/* 区切り線 */}
        <div className="w-full h-px bg-stone-800 mb-6" />

        {/* コピーライト */}
        <div className="text-center space-y-2">
          <p className="text-xs text-stone-600 tracking-wider leading-relaxed">
            © 2024 Mugi Cha Production. All rights reserved.
          </p>
          <p className="text-xs text-stone-600 tracking-wider">
            18歳未満の方のご利用はお断りしております。
          </p>
          <p className="text-xs text-stone-500 tracking-widest font-medium">
            無店舗型性風俗特殊営業届出済
          </p>
        </div>

      </div>
    </footer>
  );
}
